import { Dispatch } from '@reduxjs/toolkit'
import { clearState, isFetching, updateUserData } from './slice'
import { api } from '~/services/api'
import { login } from '~/services/auth'
import { ls } from '~/utils/localStorage'
import { updateNotification } from '../app/slice'
import { NotificationTypes } from '../app/types'

export const loginWithAdmin =
  (params: { email: string; password: string }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(isFetching())

    try {
      const { data, token } = await login(params)

      ls.set('user', data)
      ls.set('is_auth', true)
      ls.set('is_fetching', false)
      ls.set('token', token)

      dispatch(
        updateUserData({
          data,
        })
      )
      localStorage.setItem('role', data?.role)
      const departmentObject = data?.department
      localStorage.setItem('department', JSON.stringify(departmentObject))
      api.setApiDefaultsHeaders(token)
    } catch (error) {
      const message = (error as any)?.message || 'An error occurred'
      dispatch(
        updateNotification({
          text: error?.response?.data?.error?.message || message,
          type: NotificationTypes.ERROR,
        })
      )
      dispatch(clearState())
    }
  }

export const logout =
  () =>
  (dispatch: Dispatch): void => {
    dispatch(clearState())
    ls.remove('user')
  }
